export const services = [
    {
        id: 1,
        title: 'HVAC Systems',
        description: 'Complete installation, maintenance, and repair of heating, ventilation, and air conditioning systems.',
        features: ['Chiller Systems', 'VRF Systems', 'Split AC Units', 'Ductwork Installation']
    },
    {
        id: 2,
        title: 'Electrical Works',
        description: 'Professional electrical installations, maintenance, and troubleshooting services.',
        features: ['Wiring & Rewiring', 'Panel Installation', 'Lighting Systems', 'Safety Inspections']
    },
    {
        id: 3,
        title: 'Plumbing Services',
        description: 'Comprehensive plumbing solutions for residential, commercial, and industrial properties.',
        features: ['Pipe Installation', 'Drainage Systems', 'Water Supply', 'Maintenance & Repair']
    },
    {
        id: 4,
        title: 'Waterproofing Solutions',
        description: 'Specialized waterproofing services to protect structures from moisture damage.',
        features: ['Roof Waterproofing', 'Bathroom Sealing', 'Basement Protection', 'Pool Waterproofing']
    },
    {
        id: 5,
        title: 'Civil Construction',
        description: 'Complete civil engineering and construction services for all types of projects.',
        features: ['Structural Repairs', 'Concrete Restoration', 'Building Construction', 'Site Development']
    },
    {
        id: 6,
        title: 'Metal & Aluminum Work',
        description: 'Custom fabrication and installation of metal and aluminum structures.',
        features: ['Windows & Doors', 'Railings & Gates', 'Cladding Systems', 'Structural Fabrication']
    },
    {
        id: 7,
        title: 'Painting Services',
        description: 'Interior and exterior painting with premium quality materials and finishes.',
        features: ['Surface Preparation', 'Color Consultation', 'Texture Finishes', 'Protective Coating']
    },
    {
        id: 8,
        title: 'Carpentry & Woodwork',
        description: 'Custom carpentry solutions including furniture, cabinets, and wooden structures.',
        features: ['Custom Furniture', 'Cabinet Making', 'Wood Flooring', 'Decorative Work']
    },
    {
        id: 9,
        title: 'Tiling Works',
        description: 'Professional tile installation for floors, walls, and exterior surfaces.',
        features: ['Ceramic Tiles', 'Porcelain Tiles', 'Marble & Granite', 'Mosaic Patterns']
    }
];

export const teamMembers = [
    {
        id: 1,
        name: 'Omar Abdulaziz',
        position: 'Founder and CEO',
        experience: '30+ Years Experience',
        education: 'Civil Engineer',
        bio: 'Civil Engineer from Jamia Millia Islamia with 30 years of experience in Construction Projects. Over 20 years of UAE experience overseeing large-scale residential, commercial, and infrastructure projects.',
        image: '/assets/images/omar.jpeg'
    },

    {
        id: 2,
        name: 'Asad Mahboob',
        position: 'Mechanical HVAC Projects Head',
        experience: '30+ Years Experience',
        education: 'Mechanical Engineer',
        bio: 'Mechanical Engineer from Jamia Millia Islamia with 30 years of experience in civil/mechanical and industrial construction sectors. Excellent project management skills and analytical abilities.',
        image: '/assets/images/ASAD.jpg'
    },
    {
        id: 3,
        name: 'Naved Usmani',
        position: 'Civil Projects Head',
        experience: '30+ Years Experience',
        education: 'Civil Engineer',
        bio: 'Civil Engineer from Jamia Millia Islamia with 30 years of experience in Construction Projects. Over 20 years of UAE experience overseeing large-scale residential, commercial, and infrastructure projects.',
        image: '/assets/images/NAVED.jpg'
    },
    {
        id: 4,
        name: 'Mohd Sohag',
        position: 'Sales Supervisor',
        experience: '20+ Years Experience',
        education: 'First Generation Entrepreneur',
        bio: 'Built LAMSAT from scratch with over 20 years of work experience in UAE. Hands-on experience in Electrical and Plumbing works with a flair for execution and delivering projects on time with quality.',
        image: '/assets/images/sohag.jpeg'
    }
];

// Fixed blogPosts with proper structure
export const blogPosts = [
    {
        id: 1,
        title: 'Essential HVAC Maintenance Tips for Dubai Summer',
        excerpt: 'Learn how to optimize your HVAC system performance during peak summer months in Dubai.',
        category: 'HVAC',
        date: 'March 15, 2024',
        image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        author: {
            name: 'Asad Mahboob',
            role: 'HVAC Projects Head',
            avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80'
        }
    },
    {
        id: 2,
        title: 'Choosing the Right Waterproofing Solution',
        excerpt: 'A comprehensive guide to selecting the best waterproofing system for your property.',
        category: 'Construction',
        date: 'February 28, 2024',
        image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        author: {
            name: 'Naved Usmani',
            role: 'Civil Projects Head',
            avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80'
        }
    },
    {
        id: 3,
        title: 'Electrical Safety Standards in UAE Construction',
        excerpt: 'Understanding and implementing electrical safety protocols in construction projects.',
        category: 'Electrical',
        date: 'February 10, 2024',
        image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        author: {
            name: 'Mohd Sohag',
            role: 'Founder & CEO',
            avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80'
        }
    }
];

export const stats = [
    { value: '72+', label: 'Building Projects' },
    { value: '30+', label: 'Years Experience' },
    { value: '500+', label: 'Projects Completed' },
    { value: '100%', label: 'Client Satisfaction' }
];

export const whyChooseUs = [
    {
        icon: 'fa-award',
        title: 'Proven Track Record',
        description: 'Successful completion of numerous large-scale projects across UAE'
    },
    {
        icon: 'fa-users',
        title: 'Expert Team',
        description: 'Skilled professionals with vast industry experience and qualifications'
    },
    {
        icon: 'fa-gem',
        title: 'Quality Materials',
        description: 'Use of premium materials ensuring durability and lasting results'
    },
    {
        icon: 'fa-shield-alt',
        title: 'Compliance & Safety',
        description: 'Strict adherence to UAE regulations and safety protocols'
    },
    {
        icon: 'fa-clock',
        title: 'Timely Execution',
        description: 'Efficient project management ensuring on-time project completion'
    },
    {
        icon: 'fa-headset',
        title: '24/7 Support',
        description: 'Round-the-clock emergency services and maintenance support'
    }
];